import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';

// Türkçe karakterleri düzgün göstermek için encoding
const encodeTurkishText = (text) => {
  if (!text) return '';
  return text
    .replace(/ğ/g, 'g')
    .replace(/Ğ/g, 'G')
    .replace(/ü/g, 'u')
    .replace(/Ü/g, 'U')
    .replace(/ş/g, 's')
    .replace(/Ş/g, 'S')
    .replace(/ı/g, 'i')
    .replace(/İ/g, 'I')
    .replace(/ö/g, 'o')
    .replace(/Ö/g, 'O')
    .replace(/ç/g, 'c')
    .replace(/Ç/g, 'C');
};

// Tarih formatını düzenle
const formatDate = (dateString) => {
  if (!dateString) return '-';
  return moment(dateString).format('DD.MM.YYYY HH:mm');
};

// Tek form PDF export fonksiyonu
export const exportSingleFormToPDF = async (form, appToken, userData, message) => {
  const hide = message.loading('PDF hazirlaniyor...', 0);
  try {
    // formContent string'ini parse edelim
    let formContent;
    try {
      let cleanFormContent = form.formContent;
      if (typeof cleanFormContent === 'string') {
        cleanFormContent = cleanFormContent.replace(/\\"/g, '"').replace(/\\\\/g, '\\');
      }
      
      formContent = typeof cleanFormContent === 'string' 
        ? JSON.parse(cleanFormContent)
        : cleanFormContent;
    } catch (error) {
      console.error('Form içeriği parse edilemedi:', error);
      hide();
      message.error('Form içeriği okunamadi');
      return;
    }

    const fields = Array.isArray(formContent.fields) ? formContent.fields : [];
    const formTitle = formContent.title || form.title || 'İsimsiz Form';
    const formDescription = formContent.description || '';

    // PDF dokümanını oluştur
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
      putOnlyUsedFonts: true,
      floatPrecision: 16
    });

    doc.setFont('helvetica');
    doc.setLanguage('tr');

    let yOffset = 20;
    const margin = 15;
    const lineHeight = 6;
    const pageWidth = doc.internal.pageSize.width;
    const contentWidth = pageWidth - (margin * 2);

    // Form başlığı
    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    const encodedTitle = encodeTurkishText(formTitle);
    const titleWidth = doc.getTextWidth(encodedTitle);
    const titleX = titleWidth > contentWidth ? margin : (pageWidth - titleWidth) / 2;
    doc.text(encodedTitle, titleX, yOffset);
    yOffset += lineHeight + 4;

    // Form açıklaması
    if (formDescription) {
      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(80, 80, 80);
      const encodedDescription = encodeTurkishText(formDescription);
      doc.text(encodedDescription, margin, yOffset);
      yOffset += lineHeight + 6;
    }

    // Form alanlarını render et
    if (fields.length > 0) {
      for (let i = 0; i < fields.length; i++) {
        const field = fields[i];
        
        // Yeni sayfa kontrolü
        if (yOffset > doc.internal.pageSize.height - 80) {
          doc.addPage();
          yOffset = 20;
        }

        // Alan etiketi
        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(0, 0, 0);
        const encodedLabel = encodeTurkishText(field.label || 'Etiket Yok');
        doc.text(encodedLabel, margin, yOffset);
        yOffset += lineHeight + 1;

        // Alan tipine göre input alanı çiz
        const fieldWidth = field.size === '6' ? 70 : field.size === '4' ? 60 : 140;
        const fieldHeight = field.type === 'textarea' ? 15 : 8;
        
        // Input alanı çerçevesi
        doc.setDrawColor(160, 160, 160);
        doc.setFillColor(255, 255, 255);
        doc.rect(margin, yOffset - 2, fieldWidth, fieldHeight, 'FD');
        
        // Placeholder veya örnek değer
        if (field.placeholder) {
          doc.setFontSize(9);
          doc.setFont('helvetica', 'normal');
          doc.setTextColor(120, 120, 120);
          const encodedPlaceholder = encodeTurkishText(field.placeholder);
          doc.text(encodedPlaceholder, margin + 2, yOffset + 4);
        }

        // Alan tipine göre özel görünüm
        switch (field.type) {
          case 'select':
            // Dropdown ok işareti
            doc.setFontSize(8);
            doc.setTextColor(80, 80, 80);
            doc.text('▼', margin + fieldWidth - 8, yOffset + 4);
            break;
          case 'date':
            // Takvim ikonu
            doc.setFontSize(8);
            doc.setTextColor(80, 80, 80);
            doc.text('📅', margin + fieldWidth - 8, yOffset + 4);
            break;
          case 'checkbox':
            // Checkbox kutusu
            doc.rect(margin, yOffset - 2, 6, 6, 'S');
            doc.setFontSize(8);
            doc.setFont('helvetica', 'normal');
            doc.setTextColor(80, 80, 80);
            doc.text('☐', margin + 1, yOffset + 1);
            break;
          case 'radio':
            // Radio button
            doc.circle(margin + 3, yOffset + 2, 3, 'S');
            doc.setFontSize(8);
            doc.setTextColor(80, 80, 80);
            doc.text('○', margin + 1, yOffset + 1);
            break;
          case 'textarea':
            // Çok satırlı alan
            doc.setFontSize(9);
            doc.setFont('helvetica', 'normal');
            doc.setTextColor(120, 120, 120);
            doc.text('Cok satirli metin alani...', margin + 2, yOffset + 8);
            break;
          case 'file':
          case 'image':
            // Dosya yükleme alanı
            doc.setFontSize(9);
            doc.setFont('helvetica', 'normal');
            doc.setTextColor(120, 120, 120);
            doc.text('📎 Dosya seciniz', margin + 2, yOffset + 4);
            break;
          case 'email':
            // Email alanı
            doc.setFontSize(9);
            doc.setFont('helvetica', 'normal');
            doc.setTextColor(120, 120, 120);
            doc.text('ornek@email.com', margin + 2, yOffset + 4);
            break;
          case 'phone':
            // Telefon alanı
            doc.setFontSize(9);
            doc.setFont('helvetica', 'normal');
            doc.setTextColor(120, 120, 120);
            doc.text('+90 555 123 45 67', margin + 2, yOffset + 4);
            break;
          case 'number':
            // Sayı alanı
            doc.setFontSize(9);
            doc.setFont('helvetica', 'normal');
            doc.setTextColor(120, 120, 120);
            doc.text('0', margin + 2, yOffset + 4);
            break;
        }

        yOffset += fieldHeight + 6;

        // Yardım metni
        if (field.helpText) {
          doc.setFontSize(8);
          doc.setFont('helvetica', 'normal');
          doc.setTextColor(80, 80, 80);
          const encodedHelpText = encodeTurkishText(field.helpText);
          doc.text(encodedHelpText, margin, yOffset);
          yOffset += lineHeight;
        }

        // Zorunlu alan işareti
        if (field.required) {
          doc.setFontSize(7);
          doc.setTextColor(255, 0, 0);
          doc.text('* Zorunlu alan', margin, yOffset);
          yOffset += lineHeight;
        }

        yOffset += lineHeight; // Alanlar arası boşluk
      }
    }

    // Form bilgileri (sayfa altında küçük)
    yOffset = doc.internal.pageSize.height - 20;
    
    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(100, 100, 100);
    const formInfo = `Form ID: ${form.formId} | Olusturulma: ${formatDate(form.createDate)} | Yanit: ${form.records || 0}`;
    doc.text(formInfo, margin, yOffset);

    // PDF'i indir
    const fileName = `${formTitle.replace(/[^a-zA-Z0-9]/g, '_')}_${form.formId}_${new Date().toISOString().split('T')[0]}.pdf`;
    doc.save(fileName);
    hide();
    message.success('PDF dosyasi basariyla indirildi');
  } catch (error) {
    hide();
    console.error('PDF dışa aktarma hatası:', error);
    message.error(`PDF dosyasi olusturulurken bir hata olustu: ${error.message}`);
  }
};

// Toplu PDF export fonksiyonu
export const exportMultipleFormsToPDF = async (formsToExport, message) => {
  if (formsToExport.length === 0) {
    message.warning('Dışa aktarılacak form bulunamadi');
    return;
  }

  const hide = message.loading(`${formsToExport.length} form için PDF hazirlaniyor...`, 0);
  try {
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
      putOnlyUsedFonts: true,
      floatPrecision: 16
    });

    doc.setFont('helvetica');
    doc.setLanguage('tr');

    const margin = 15;
    const lineHeight = 6;
    const pageWidth = doc.internal.pageSize.width;
    const contentWidth = pageWidth - (margin * 2);

    let currentPage = 1;
    let yOffset = 20;

    // Ana başlık
    doc.setFillColor(59, 130, 246);
    doc.rect(0, 0, pageWidth, 35, 'F');
    
    doc.setFontSize(20);
    doc.setTextColor(255, 255, 255);
    const mainTitle = 'Form Kutuphanesi Raporu';
    const mainTitleWidth = doc.getTextWidth(mainTitle);
    const mainTitleX = mainTitleWidth > contentWidth ? margin : (pageWidth - mainTitleWidth) / 2;
    doc.text(mainTitle, mainTitleX, 25);
    
    doc.setFontSize(10);
    doc.text(`Olusturulma Tarihi: ${new Date().toLocaleDateString('tr-TR')}`, margin, 35);
    
    yOffset = 45;

    // Özet tablosu
    doc.setFontSize(12);
    doc.setTextColor(59, 130, 246);
    doc.text('Form Ozeti', margin, yOffset);
    yOffset += lineHeight + 3;

    const summaryData = [
      ['Toplam Form Sayisi', formsToExport.length.toString()],
      ['Aktif Formlar', formsToExport.filter(f => f.isActive).length.toString()],
      ['Pasif Formlar', formsToExport.filter(f => !f.isActive).length.toString()],
      ['Toplam Yanit', formsToExport.reduce((sum, f) => sum + (f.records || 0), 0).toString()],
      ['Ortalama Yanit/Form', Math.round(formsToExport.reduce((sum, f) => sum + (f.records || 0), 0) / formsToExport.length).toString()]
    ];

    doc.autoTable({
      body: summaryData,
      startY: yOffset,
      margin: { left: margin, right: margin },
      styles: { 
        fontSize: 9,
        cellPadding: 3,
        lineColor: [59, 130, 246],
        lineWidth: 0.1,
        font: 'helvetica',
        fontStyle: 'normal'
      },
      headStyles: { 
        fillColor: [59, 130, 246],
        textColor: [255, 255, 255],
        fontSize: 10,
        fontStyle: 'bold',
        font: 'helvetica'
      },
      alternateRowStyles: {
        fillColor: [248, 250, 252]
      },
      columnStyles: {
        0: { cellWidth: 70, fontStyle: 'bold' },
        1: { cellWidth: 80 }
      }
    });

    yOffset = doc.lastAutoTable.finalY + 15;

    // Her form için detaylı bölüm
    for (let i = 0; i < formsToExport.length; i++) {
      const form = formsToExport[i];
      
      // Yeni sayfa kontrolü
      if (yOffset > doc.internal.pageSize.height - 100) {
        doc.addPage();
        currentPage++;
        yOffset = 20;
      }

      // Form başlığı
      doc.setFontSize(14);
      doc.setTextColor(59, 130, 246);
      doc.text(`${i + 1}. ${encodeTurkishText(form.title || 'İsimsiz Form')}`, margin, yOffset);
      yOffset += lineHeight + 3;

      // Form bilgileri tablosu
      const formInfoData = [
        ['Form ID', form.formId],
        ['Durum', form.isActive ? 'Aktif' : 'Pasif'],
        ['Yanit Sayisi', (form.records || 0).toString()],
        ['Olusturulma', formatDate(form.createDate)],
        ['Guncelleme', formatDate(form.editDate)]
      ];

      doc.autoTable({
        body: formInfoData,
        startY: yOffset,
        margin: { left: margin, right: margin },
        styles: { 
          fontSize: 8,
          cellPadding: 2,
          lineColor: [59, 130, 246],
          lineWidth: 0.1,
          font: 'helvetica',
          fontStyle: 'normal'
        },
        headStyles: { 
          fillColor: [59, 130, 246],
          textColor: [255, 255, 255],
          fontSize: 9,
          fontStyle: 'bold',
          font: 'helvetica'
        },
        alternateRowStyles: {
          fillColor: [248, 250, 252]
        },
        columnStyles: {
          0: { cellWidth: 35, fontStyle: 'bold' },
          1: { cellWidth: 115 }
        }
      });

      yOffset = doc.lastAutoTable.finalY + 8;

      // Form içeriği varsa parse et
      if (form.formContent) {
        try {
          let cleanFormContent = form.formContent;
          if (typeof cleanFormContent === 'string') {
            cleanFormContent = cleanFormContent.replace(/\\"/g, '"').replace(/\\\\/g, '\\');
          }
          
          const formContent = typeof cleanFormContent === 'string' 
            ? JSON.parse(cleanFormContent)
            : cleanFormContent;

          const fields = Array.isArray(formContent.fields) ? formContent.fields : [];
          
          if (fields.length > 0) {
            // Alan özeti
            doc.setFontSize(10);
            doc.setTextColor(59, 130, 246);
            doc.text('Form Alanlari:', margin, yOffset);
            yOffset += lineHeight;

            // Alan tiplerini grupla
            const fieldTypes = {};
            fields.forEach(field => {
              const type = field.type || 'text';
              fieldTypes[type] = (fieldTypes[type] || 0) + 1;
            });

            Object.entries(fieldTypes).forEach(([type, count]) => {
              doc.setFontSize(8);
              doc.setTextColor(0, 0, 0);
              doc.text(`  • ${type}: ${count} alan`, margin + 3, yOffset);
              yOffset += lineHeight;
            });

            // İlk 3 alanı detaylı göster
            const fieldsToShow = fields.slice(0, 3);
            if (fieldsToShow.length > 0) {
              yOffset += lineHeight;
              doc.setFontSize(8);
              doc.setTextColor(59, 130, 246);
              doc.text('Ornek Alanlar:', margin, yOffset);
              yOffset += lineHeight;

              fieldsToShow.forEach((field, index) => {
                doc.setFontSize(7);
                doc.setTextColor(0, 0, 0);
                const fieldInfo = `  ${index + 1}. ${encodeTurkishText(field.label || 'Etiket Yok')} (${field.type || 'text'})`;
                doc.text(fieldInfo, margin + 3, yOffset);
                yOffset += lineHeight;
              });

              if (fields.length > 3) {
                doc.text(`  ... ve ${fields.length - 3} alan daha`, margin + 3, yOffset);
                yOffset += lineHeight;
              }
            }
          }
        } catch (error) {
          doc.setFontSize(8);
          doc.setTextColor(128, 128, 128);
          doc.text('Form içeriği okunamadi', margin, yOffset);
          yOffset += lineHeight;
        }
      }

      yOffset += lineHeight * 2;

      // Sayfa numarası
      doc.setFontSize(7);
      doc.setTextColor(128, 128, 128);
      doc.text(
        `Sayfa ${currentPage}`,
        pageWidth / 2,
        doc.internal.pageSize.height - 8,
        { align: 'center' }
      );
    }

    // PDF'i indir
    const fileName = `form_kutuphanesi_raporu_${new Date().toISOString().split('T')[0]}.pdf`;
    doc.save(fileName);
    hide();
    message.success(`${formsToExport.length} form basariyla PDF olarak disa aktarildi`);
  } catch (error) {
    hide();
    console.error('Toplu PDF dışa aktarma hatası:', error);
    message.error(`PDF dosyasi olusturulurken bir hata olustu: ${error.message}`);
  }
};

// Form yanıtını PDF olarak export etme fonksiyonu
export const exportFormResponseToPDF = async (formData) => {
  try {
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
      putOnlyUsedFonts: true,
      floatPrecision: 16
    });

    doc.setFont('helvetica');
    doc.setLanguage('tr');

    let yOffset = 20;
    const margin = 15;
    const lineHeight = 6;
    const pageWidth = doc.internal.pageSize.width;
    const contentWidth = pageWidth - (margin * 2);

    // Doküman başlığı
    doc.setFillColor(59, 130, 246);
    doc.rect(0, 0, pageWidth, 35, 'F');
    
    doc.setFontSize(18);
    doc.setTextColor(255, 255, 255);
    const title = encodeTurkishText(formData.formTitle || 'Form Yaniti');
    const titleWidth = doc.getTextWidth(title);
    const titleX = titleWidth > contentWidth ? margin : (pageWidth - titleWidth) / 2;
    doc.text(title, titleX, 22);
    
    // Doküman kontrol bilgileri varsa göster
    if (formData.settings?.documentControlEnabled) {
      doc.setFontSize(10);
      let docInfo = '';
      if (formData.settings.documentPrefix && formData.settings.documentCode) {
        docInfo += `Dok. No: ${formData.settings.documentPrefix}-${formData.settings.documentCode}`;
      }
      if (formData.settings.department) {
        docInfo += docInfo ? ` | Dept: ${formData.settings.department}` : `Dept: ${formData.settings.department}`;
      }
      if (docInfo) {
        doc.text(encodeTurkishText(docInfo), margin, 30);
      }
    }
    
    yOffset = 45;

    // Form açıklaması
    if (formData.formDescription) {
      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(80, 80, 80);
      const encodedDescription = encodeTurkishText(formData.formDescription);
      const descLines = doc.splitTextToSize(encodedDescription, contentWidth);
      doc.text(descLines, margin, yOffset);
      yOffset += (descLines.length * lineHeight) + 8;
    }

    // Form bilgileri tablosu
    const formInfoData = [
      ['Form ID', formData.formId?.toString() || '-'],
      ['Olusturulma Tarihi', formatDate(formData.createDate)],
      ['Duzenleme Tarihi', formatDate(formData.editDate)],
      ['Kullanici', encodeTurkishText(formData.user || '-')]
    ];

    doc.autoTable({
      body: formInfoData,
      startY: yOffset,
      margin: { left: margin, right: margin },
      styles: { 
        fontSize: 9,
        cellPadding: 3,
        lineColor: [200, 200, 200],
        lineWidth: 0.1,
        font: 'helvetica'
      },
      headStyles: { 
        fillColor: [240, 240, 240],
        textColor: [0, 0, 0],
        fontSize: 9,
        fontStyle: 'bold'
      },
      alternateRowStyles: {
        fillColor: [248, 250, 252]
      },
      columnStyles: {
        0: { cellWidth: 40, fontStyle: 'bold' },
        1: { cellWidth: 110 }
      }
    });

    yOffset = doc.lastAutoTable.finalY + 15;

    // Form alanları ve yanıtları
    if (formData.formFields && formData.formFields.length > 0) {
      doc.setFontSize(14);
      doc.setTextColor(59, 130, 246);
      doc.text('Form Alanlari ve Yanitlari', margin, yOffset);
      yOffset += lineHeight + 8;

      for (let i = 0; i < formData.formFields.length; i++) {
        const field = formData.formFields[i];
        
        // Yeni sayfa kontrolü
        if (yOffset > doc.internal.pageSize.height - 60) {
          doc.addPage();
          yOffset = 20;
        }

        // Alan etiketi
        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(0, 0, 0);
        const encodedLabel = encodeTurkishText(field.label || 'Etiket Yok');
        doc.text(`${i + 1}. ${encodedLabel}`, margin, yOffset);
        
        // Alan tipi
        doc.setFontSize(8);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(120, 120, 120);
        doc.text(`(${field.type?.toUpperCase() || 'TEXT'})`, margin + doc.getTextWidth(`${i + 1}. ${encodedLabel}`) + 5, yOffset);
        yOffset += lineHeight + 2;

        // Alan değeri
        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(0, 0, 0);
        
        let valueText = '';
        
        switch (field.type) {
          case 'checkbox':
            if (Array.isArray(field.value) && field.value.length > 0) {
              valueText = field.value.map(v => encodeTurkishText(v)).join(', ');
            } else {
              valueText = 'Secim yapilmadi';
            }
            break;
          case 'date':
            valueText = field.value ? formatDate(field.value) : 'Tarih secilmedi';
            break;
          case 'time':
            valueText = field.value ? field.value : 'Saat secilmedi';
            break;
          case 'email':
            valueText = field.value ? field.value : 'E-posta girilmedi';
            break;
          case 'phone':
            valueText = field.value ? field.value : 'Telefon girilmedi';
            break;
          case 'file':
          case 'image':
            if (Array.isArray(field.value) && field.value.length > 0) {
              valueText = `${field.value.length} dosya yuklendi: ` + 
                         field.value.map(f => encodeTurkishText(f.name || 'dosya')).join(', ');
            } else {
              valueText = 'Dosya yuklenmedi';
            }
            break;
          case 'signature':
            valueText = field.value ? 'Imza mevcut' : 'Imza yok';
            break;
          case 'calculation':
            if (field.value && typeof field.value === 'object') {
              valueText = 'Hesaplama tablosu mevcut';
            } else {
              valueText = 'Hesaplama yapilmadi';
            }
            break;
          case 'table':
            if (field.value && field.value.rows && field.value.rows.length > 0) {
              valueText = `Tablo: ${field.value.rows.length} satir`;
            } else {
              valueText = 'Tablo bos';
            }
            break;
          case 'name':
            if (field.value && typeof field.value === 'object') {
              valueText = encodeTurkishText(`${field.value.firstName || ''} ${field.value.lastName || ''}`.trim());
            } else {
              valueText = encodeTurkishText(field.value || 'Ad soyad girilmedi');
            }
            break;
          default:
            if (typeof field.value === 'object') {
              valueText = JSON.stringify(field.value);
            } else {
              valueText = encodeTurkishText(field.value || 'Yanit verilmedi');
            }
        }

        // Değeri birden fazla satıra böl
        const valueLines = doc.splitTextToSize(valueText, contentWidth - 10);
        
        // Değer kutusunu çiz
        const boxHeight = Math.max(8, valueLines.length * lineHeight + 4);
        doc.setDrawColor(200, 200, 200);
        doc.setFillColor(248, 250, 252);
        doc.rect(margin + 5, yOffset - 2, contentWidth - 10, boxHeight, 'FD');
        
        // Değer metnini yaz
        doc.text(valueLines, margin + 8, yOffset + 4);
        yOffset += boxHeight + 8;
      }
    }

    // İmza alanı (eğer form alanları içinde değilse)
    if (formData.signature && !formData.formFields?.some(f => f.type === 'signature')) {
      if (yOffset > doc.internal.pageSize.height - 40) {
        doc.addPage();
        yOffset = 20;
      }
      
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(0, 0, 0);
      doc.text('Imza', margin, yOffset);
      yOffset += lineHeight + 2;
      
      doc.setDrawColor(200, 200, 200);
      doc.setFillColor(248, 250, 252);
      doc.rect(margin + 5, yOffset - 2, contentWidth - 10, 20, 'FD');
      
      doc.setFontSize(10);
      doc.setTextColor(120, 120, 120);
      doc.text('Imza mevcut', margin + 8, yOffset + 10);
      yOffset += 25;
    }

    // Dosyalar (eğer form alanları içinde değilse)
    if (formData.files && Object.keys(formData.files).length > 0 && !formData.formFields?.some(f => f.type === 'file')) {
      if (yOffset > doc.internal.pageSize.height - 60) {
        doc.addPage();
        yOffset = 20;
      }
      
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(0, 0, 0);
      doc.text('Yuklenen Dosyalar', margin, yOffset);
      yOffset += lineHeight + 4;

      Object.entries(formData.files).forEach(([key, file]) => {
        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(0, 0, 0);
        const fileName = encodeTurkishText(file.name || 'dosya');
        doc.text(`• ${fileName}`, margin + 5, yOffset);
        yOffset += lineHeight;
      });
    }

    // Sayfa numarası ekle
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(120, 120, 120);
      doc.text(
        `Sayfa ${i} / ${pageCount}`,
        pageWidth / 2,
        doc.internal.pageSize.height - 8,
        { align: 'center' }
      );
    }

    // PDF'i indir
    const fileName = `form_yaniti_${formData.formId || 'unknown'}_${new Date().toISOString().split('T')[0]}.pdf`;
    doc.save(fileName);
    
  } catch (error) {
    console.error('Form yanıt PDF export hatası:', error);
    throw error;
  }
}; 